import React from 'react';
import { Cell, Sector } from 'recharts';
import type { PieSectorDataItem } from 'recharts/types/polar/Pie';
import type { DonutDataItem } from 'redux/modules/superreports.types';
import { cssVariables } from 'styles';
import { getColor } from './helpers';

export const renderDonutWidgetPieCells = (data: Array<DonutDataItem>) => {
  let accumulatedPercent = 0;
  return data.map(({ value, mergedItems, color, percentOfTotal }, index) => {
    const colorPercent = accumulatedPercent + percentOfTotal / 2;
    const fill = (Array.isArray(color) ? color[1] : color) ?? getColor(colorPercent);
    accumulatedPercent += percentOfTotal;
    return (
      <Cell key={`${value}-${index}`} fill={!mergedItems ? fill : cssVariables.widgetOtherColor} />
    );
  });
};

/**
 * Number of pixels to grow the currently hovered donut sector by.
 */
export const ACTIVE_DONUT_SECTOR_GROWTH = 5;

/**
 * Renders the currently active donut sector slightly bigger to make it stand out.
 */
export const ActiveDonutSector = ({
  cx,
  cy,
  innerRadius,
  outerRadius,
  startAngle,
  endAngle,
  fill,
}: PieSectorDataItem): React.ReactElement<React.SVGProps<SVGSVGElement>> => (
  <g>
    <Sector
      cx={cx}
      cy={cy}
      innerRadius={innerRadius! - ACTIVE_DONUT_SECTOR_GROWTH}
      outerRadius={outerRadius}
      startAngle={startAngle}
      endAngle={endAngle}
      fill={fill}
      stroke="none"
    />
  </g>
);
